import _toConsumableArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { createFsCacheProxy } from '@segment/utils/fsCache';
export var attributesToFetch = ["contentType", "slug", "name", "logo", "categories", "type", "beta"];
var DESTINATION_FILTER = "type:destination";
var SOURCE_FILTER = "type:source";
var INTEGRATIONS_CONTENT_TYPE = "contentType:integrations";
export var fetchIntegrations = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var query, catalogIndex, pageParam, category, _ref$distinct, distinct, hitsPerPage, source, destination, _ref$categoryNegation, categoryNegation, extFilters, cacheKey, enabled, algoliaCachedSearch, categoryFilters, typeFilters, filters;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = _ref.query, catalogIndex = _ref.catalogIndex, pageParam = _ref.pageParam, category = _ref.category, _ref$distinct = _ref.distinct, distinct = _ref$distinct === void 0 ? 0 : _ref$distinct, hitsPerPage = _ref.hitsPerPage, source = _ref.source, destination = _ref.destination, _ref$categoryNegation = _ref.categoryNegation, categoryNegation = _ref$categoryNegation === void 0 ? false : _ref$categoryNegation, extFilters = _ref.filters, cacheKey = _ref.cacheKey;
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            _context.next = 4;
            return createFsCacheProxy(["catalog-fetchIntegrations"].concat(_toConsumableArray(cacheKey ? cacheKey : [query, pageParam !== null && pageParam !== void 0 ? pageParam : null, category !== null && category !== void 0 ? category : null, distinct !== null && distinct !== void 0 ? distinct : null, hitsPerPage !== null && hitsPerPage !== void 0 ? hitsPerPage : null, source !== null && source !== void 0 ? source : null, destination !== null && destination !== void 0 ? destination : null, categoryNegation !== null && categoryNegation !== void 0 ? categoryNegation : null, extFilters !== null && extFilters !== void 0 ? extFilters : null])), function () {
              return catalogIndex.search.apply(catalogIndex, arguments);
            }, {
              enabled: enabled
            });

          case 4:
            algoliaCachedSearch = _context.sent;
            categoryFilters = typeof category === "string" ? (categoryNegation ? "NOT " : "") + "categories.category.slug:".concat(category) : undefined;
            typeFilters = [];
            if (destination) typeFilters.push(DESTINATION_FILTER);
            if (source) typeFilters.push(SOURCE_FILTER);
            if (!source && !destination) typeFilters.push("NOT ".concat(DESTINATION_FILTER, " AND NOT ").concat(SOURCE_FILTER));
            filters = [categoryFilters, extFilters, "(".concat(typeFilters.join(" OR "), ")"), INTEGRATIONS_CONTENT_TYPE].filter(function (filter) {
              return filter && filter !== "()";
            }).join(" AND ");
            return _context.abrupt("return", algoliaCachedSearch(query, {
              attributesToRetrieve: ["-*"].concat(attributesToFetch),
              distinct: distinct,
              page: pageParam !== null && pageParam !== void 0 ? pageParam : 0,
              hitsPerPage: hitsPerPage,
              filters: filters
            }));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchIntegrations(_x) {
    return _ref2.apply(this, arguments);
  };
}();